import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect, useMemo } from 'react';
import { useFeature } from '@growthbook/growthbook-react';
import {
  isLoggedInSelector,
  userNumberSelector,
} from '../../redux/reducers/app/params';
import {
  hideRecentGamesModal,
  showRecentGamesModal,
} from '../../redux/actions/ui/modals';
import { localStorageAccessor } from '../../utils/localStorage';
import FEATURES from '../../constants/featureToggling';

const LOCAL_STORAGE_KEY = `casino:recent_games_migration_process#`;

let wasShownDuringSession = false;

export const useMigrationModalManager = () => {
  const dispatch = useDispatch();
  const isLoggedIn = useSelector(isLoggedInSelector);
  const userNumber = useSelector(userNumberSelector);

  const isFeatureEnabled = useFeature(FEATURES.SHOW_RECENTS_MIGRATION_MODAL).on;

  const localStorageKey = useMemo(
    () => LOCAL_STORAGE_KEY.concat(userNumber),
    [userNumber]
  );

  useEffect(() => {
    const data = localStorageAccessor(localStorageKey);
    const isShown =
      isFeatureEnabled &&
      isLoggedIn &&
      !wasShownDuringSession &&
      !data?.dontShowAgain;

    if (isShown) {
      dispatch(showRecentGamesModal());
    }
  }, [localStorageKey, dispatch, isFeatureEnabled, isLoggedIn]);

  const hideModal = useCallback(
    (dontShowAgain = false) => {
      wasShownDuringSession = true;

      if (dontShowAgain) {
        localStorageAccessor(localStorageKey, { dontShowAgain });
      }

      dispatch(hideRecentGamesModal());
    },
    [localStorageKey, dispatch]
  );

  return {
    hideModal,
  };
};
